<template>
  <div>
    <div class="text item text-center">
      <div class="pull-right" style="margin-bottom: 15px">
        <el-button type="primary" size="medium" @click="InquiryAward()">预中标描述</el-button>

        <el-button type="primary" size="medium" @click="exportExcel()">导出</el-button>
        <!-- <el-button type="warning" size="medium">分标段授标</el-button> -->
        <el-button type="warning" size="medium" @click="SetInquiryAwardList()">授标</el-button>
        <!-- <el-button type="primary" size="medium">预中标描述</el-button> -->
        <!-- <el-button type="info" size="medium">OA签批</el-button> -->
      </div>
    </div>

    <el-table :data="dt2table1" @selection-change="handleSelectionChange" max-height="480" class="tb-edit"
      style="width: 100%" ref="multipleTable" :header-cell-style="{ 'text-align': 'center' }">
      <el-table-column type="selection" width="55" :selectable="checkSelectable">
      </el-table-column>
      <el-table-column label="公司信息" width="180" prop="cpasturename">
      </el-table-column>
      <el-table-column label="授标状态" width="80" prop="cisaward_inv">
      </el-table-column>
      <el-table-column label="物料信息" width="180" prop="cinvname_price">
      </el-table-column>
      <!-- <el-table-column label="物料描述" width="180" prop="">
      </el-table-column> -->
      <el-table-column label="单位" width="55" prop="cunit_price">
      </el-table-column>
      <el-table-column label="询价数量" width="80" prop="ipricenum">
      </el-table-column>
      <el-table-column label="送达方名称" width="120" prop="cjhname">
      </el-table-column>
      <el-table-column label="集团最近价" width="100" prop="igroupprice">
      </el-table-column>
      <el-table-column label="公司最近价" width="100" prop="ipastureprice">
      </el-table-column>
      <el-table-column label="报价结果">
        <template>
          <el-table-column label="最低报价" width="110" prop="iminprice">
          </el-table-column>
          <el-table-column label="最低厂商" width="160" prop="cmininfo">
          </el-table-column>
          <el-table-column label="预中标信息" width="160" prop="cbidvenname">
          </el-table-column>-
          <el-table-column label="预中标数量" width="110" prop="iprenum_price">
          </el-table-column>
        </template>
      </el-table-column>
      <el-table-column v-for="(item, i) in tableHead" :key="i" :label="item.label" :property="item.property"
        width="180">
        <template slot-scope="scope" v-if="item.child.length == 0">
          {{ scope.row[scope.column.property] }}
        </template>
        <template v-if="item.child.length != 0">
          <el-table-column v-for="(temchild, index) in item.child" :key="index" :label="temchild.label"
            :property="temchild.property" width="120">
          </el-table-column>
        </template>
      </el-table-column>
      <!-- <el-table-column label="预中标信息" width="110" prop="">
      </el-table-column> -->

      <el-table-column label="操作" fixed="right" width="120" v-if="dt.cfbwl != '是'">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain @click="handleEdit(scope.row, scope.$index)">分标段授标</el-button>
          <!-- <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
          <!-- <el-button size="mini" type="primary" plain @click="handleEdit(scope.row,scope.$index)">分标段授标</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-table v-show="ecel" :data="dt2table1" id="out-table" class="tb-edit" style="width: 100%" ref="multipleTable"
      :header-cell-style="{ 'text-align': 'center' }">
      <el-table-column label="公司信息" width="180" prop="cpasturename">
      </el-table-column>
      <el-table-column label="授标状态" width="80" prop="cisaward_inv">
      </el-table-column>
      <el-table-column label="物料信息" width="180" prop="cinvname_price">
      </el-table-column>
      <!-- <el-table-column label="物料描述" width="180" prop="">
      </el-table-column> -->
      <el-table-column label="单位" width="55" prop="cunit_price">
      </el-table-column>
      <el-table-column label="询价数量" width="80" prop="ipricenum">
      </el-table-column>
      <el-table-column label="送达方名称" width="120" prop="cjhname">
      </el-table-column>
      <el-table-column label="集团最近价" width="100" prop="igroupprice">
      </el-table-column>
      <el-table-column label="公司最近价" width="100" prop="ipastureprice">
      </el-table-column>
      <el-table-column label="报价结果">
        <template>
          <el-table-column label="最低报价" width="120" prop="iminprice">
          </el-table-column>
          <el-table-column label="最低厂商" width="160" prop="cmininfo">
          </el-table-column>
          <el-table-column label="预中标信息" width="160" prop="cbidvenname">
          </el-table-column>
          <el-table-column label="预中标数量" width="120" prop="iprenum_price">
          </el-table-column>
        </template>
      </el-table-column>
      <el-table-column v-for="(item, i) in tableHead" :key="i" :label="item.label" :property="item.property"
        width="180">
        <template slot-scope="scope" v-if="item.child.length == 0">
          {{ scope.row[scope.column.property] }}
        </template>
        <template v-if="item.child.length != 0">
          <el-table-column v-for="(temchild, index) in item.child" :key="index" :label="temchild.label"
            :property="temchild.property" width="120">
          </el-table-column>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="" :visible.sync="dialogFormVisible" customClass="way sadform" :append-to-body="true">
      <!-- <el-form ref="sdaruleForm" :rules="sdarules" :model="sdaform" label-width="110px" class="form01"> -->
      <el-row :gutter="20" class="rowdig" v-if="dialogFormVisible">
        <el-col :span="12">
          <span><b>工厂:</b></span><span>{{ sdaform.cpasturename }}</span>
          <!-- <el-form-item label="工厂:" prop="cusername">
              <el-input v-model="sdaform.cusername" placeholder="请输入工厂"></el-input>
            </el-form-item> -->
        </el-col>
        <el-col :span="12">
          <span><b>物料:</b></span><span>{{ sdaform.cinvname }}</span>
          <!-- <el-form-item label="物料描述:" prop="cusername">
              <el-input v-model="sdaform.cusername" placeholder="请输入物料描述"></el-input>
            </el-form-item> -->
        </el-col>

        <el-col :span="12">
          <span><b>询价数量:</b></span><span>{{ sdaform.inumber }}</span>
          <!-- <el-form-item label="询价数量:" prop="inumber">
              <el-input v-model="sdaform.cusername" placeholder="请输入职位"></el-input>
            </el-form-item> -->
        </el-col>
        <el-col :span="12">
          <span><b>计量单位:</b></span><span>{{ sdaform.cunit }}</span>
          <!-- <el-form-item label="计量单位:" prop="cusername">
              <el-input v-model="sdaform.cusername" placeholder="请输入手机"></el-input>
            </el-form-item> -->
        </el-col>
        <el-col :span="24"> </el-col>
      </el-row>
      <el-table :data="digedtable" v-if="dialogFormVisible" class="tb-edit" ref="sitesTable" style="width: 100%"
        row-key="op_inquiry_price_autoid" border @selection-change="tablechange">
        <el-table-column type="selection" width="45" align="center" :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="cvenname_price" label="供应商">
        </el-table-column>
        <el-table-column prop="iyf_price" label="单价" width="60">
        </el-table-column>
        <el-table-column prop="iqjnumber" label="本次分配数量" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.iqjnumber" placeholder="本次分配数量" size="mini"
              @blur="setinput(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="cpriceremark" label="备注" width="120">
        </el-table-column>
      </el-table>
      <!-- </el-form> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad()">取 消</el-button>
        <el-button type="success" @click="shoubiaoconfirm()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="预中标描述" :visible.sync="dialogcdescribe" customClass="way describ" :append-to-body="true">
      <el-form :model="dt" ref="dataForm" class="demo-dynamic" v-if="dialogcdescribe">
        <el-form-item label="预中标描述" prop="account">
          <el-input v-model="dt.cdescribe" type="textarea" rows="5" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>

      <!-- </el-form> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad()">取 消</el-button>
        <el-button type="success" @click="SetInquiryAward()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import FileSaver from "file-saver";
  import XLSX from "xlsx";
  export default {
    props: {
      dt: { type: Object },
      dt2table1: { type: Array },
      tableHead: { type: Array },
      dt2list1: { type: Array },
      dt2list: { type: Array },
      urlid: { type: String },
      cop: { type: String },
    },
    name: "ruleTable",
    data () {
      return {
        ecel: false,
        multipleSelection: [],
        multiple: [],
        dialogFormVisible: false,
        sdaform: {},
        sdarules: {
          cusername: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        },
        state: "-1",
        digedtable: [],
        sdatable: {},
        dialogcdescribe: false,
      };
    },
    created () {
      setTimeout(() => {
        console.log(this.dt2table1, "dt2table1");
      }, 2200);
    },
    mounted () { },
    methods: {
      // 预中标信息
      InquiryAward () {
        this.dialogcdescribe = true;
      },
      // 保存预中标描述
      SetInquiryAward () {
        this.$confirm("请确认保存预中标描述！！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/SetInquiryAward",
              data: {
                KeyValue: this.dt.id,
                clogincode: this.cop,
                cdescribe: this.dt.cdescribe,
              },
            })
              .then((res) => {
                console.log(res, "结果");
                setTimeout(() => {
                  if (res.data.Success) {
                    this.$message.success(res.data.Message);
                    this.closesad();
                  } else {
                    this.$message.error(res.data.Message);
                  }
                }, 10);
              })
              .catch((error) => { });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      },
      // table选中
      tablechange (val) {
        this.multiple = [];
        this.multiple = val;
        this.multiple = JSON.parse(
          JSON.stringify(this.multiple).replace(/"ifautoid"/g, '"iautoid"')
        );
      },
      //
      checkSelectable (row) {
        return row.cisaward_inv != "是";
      },
      // 选中之后值发生了变化
      setinput (row) {
        for (var a = 0; a < this.multiple.length; a++) {
          if (
            row.op_inquiry_price_autoid ==
            this.multiple[a].op_inquiry_price_autoid
          ) {
            this.multiple[a] = JSON.parse(
              JSON.stringify(row).replace(/"ifautoid"/g, '"iautoid"')
            );
          }
        }
        console.log(this.multiple);
      },
      // 授标
      SetInquiryAwardList () {
        if (this.multipleSelection.length == 0) {
          this.$message.error("请选择公司信息");
        } else {
          var awardlist = [];
          for (var a = 0; a < this.multipleSelection.length; a++) {
            awardlist.push({
              iautoid: this.multipleSelection[a].iautoid,
              cobjectcode: this.multipleSelection[a].cminvencode,
            });
          }
          console.log(awardlist);
          this.$confirm("请确认授标信息！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$axios({
                method: "post",
                url: "CommonModule/Op_Supplier/SetInquiryAwardList",
                data: {
                  KeyValue: this.urlid,
                  clogincode: this.cop,
                  JsonInfo: JSON.stringify(awardlist),
                },
              }).then((res) => {
                console.log(res, "撤销fff结果");
                if (res.data.Success) {
                  this.$message.success("授标成功！！");
                  this.$emit("rend", "1");
                } else {
                  this.$message.error(res.data.Message);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        }
      },
      //分段授标关闭
      closesad () {
        this.dialogFormVisible = false;
        this.dialogcdescribe = false;
      },
      //分段授标
      shoubiaoconfirm () {
        console.log(this.multiple, "传值");
        if (this.multiple.length != 0) {
          // var numberwl = 0;
          // for (var a = 0; a < this.digedtable.length; a++) {
          //   if (this.digedtable[a].iqjnumber == "") {
          //     this.digedtable[a].iqjnumber = 0;
          //   }
          //   numberwl += parseInt(this.digedtable[a].iqjnumber);
          // }
          for (var a = 0; a < this.digedtable.length; a++) {
            if (this.digedtable[a].iqjnumber == "") {
              this.digedtable[a].iqjnumber = 0;
            }
          }
          // if (numberwl == this.sdaform.inumber) {
          console.log(this.digedtable);
          this.digedtable = JSON.parse(
            JSON.stringify(this.digedtable).replace(/"ifautoid"/g, '"iautoid"')
          );

          this.$confirm("请确认授标信息！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$axios({
                method: "post",
                url: "CommonModule/Op_Supplier/SetInquiryAwardOne",
                data: {
                  KeyValue: this.urlid,
                  clogincode: this.cop,
                  JsonInfo: JSON.stringify(this.multiple),
                },
              }).then((res) => {
                console.log(res, "撤销fff结果");
                if (res.data.Success) {
                  this.$message.success("授标成功");
                  this.$emit("rend", "1");
                  this.dialogFormVisible = false;
                } else {
                  this.$message.error(res.data.Message);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
          // } else {
          //   this.$message.error("分配数量和询价数量不相等");
          //   return;
          // }
        } else {
          this.$message.error("请选择信息");
          return;
        }
      },
      // 获取分段授标信息
      handleEdit (row, i) {
        console.log(row);
        this.sdatable = [];
        this.digedtable = [];
        this.sdatable = row;
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetInquiryAwardOne",
          data: { iautoid: row.iautoid },
        }).then((res) => {
          console.log(res, "获取分段授标信息");
          if (res.data.Success) {
            console.log(this.tableHead, "获取分段授标信息ww");
            this.sdaform = res.data.Data.dt[0];
            this.digedtable = res.data.Data.dt2;
            //
            // this.$message.success(res.data.Message);
          } else {
            this.$message.error(res.data.Message);
          }
        });
        this.digedtable = [];

        this.dialogFormVisible = true;
      },
      //定义导出Excel表格事件
      exportExcel () {
        /* 从表生成工作簿对象 */
        var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
          raw: true,
        });
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            //Blob 对象表示一个不可变、原始数据的类文件对象。
            //Blob 表示的不一定是JavaScript原生格式的数据。
            //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
            //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
            new Blob([wbout], { type: "application/octet-stream" }),
            //设置导出文件名称
            "开标一览表.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },
      handleSelectionChange (val) {
        this.multipleSelection = val;
      },
    },
  };
</script>